import { cn } from '../lib/utils';

const LOW_TIME_SECONDS = 30;
const SECONDS_PER_MINUTE = 60;

function formatTime(secondsRemaining: number): string {
  const totalSeconds = Math.max(0, secondsRemaining);
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  const paddedSeconds = seconds.toString().padStart(2, '0');
  return `${minutes}:${paddedSeconds}`;
}

export function TestTimer({ secondsRemaining }: { secondsRemaining: number }) {
  const isLowTime = secondsRemaining <= LOW_TIME_SECONDS;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-sm font-semibold tabular-nums',
        isLowTime ? 'bg-incorrect/10 text-incorrect' : 'bg-bg-chat text-title',
      )}
    >
      {formatTime(secondsRemaining)}
    </span>
  );
}
